import { gsap } from 'gsap'

export default class TimeStage   {
  constructor(data, id){
    this._id = id
    this._data = data
    this._name =  data.name || ''
    this._startTime =  data.startTime || 0
    this._delay = data.delay || 0
    this._duration = data.duration || 0
    this._distance = data.distance || 0
    this._type = data.type || ''
    this._isComplete = false
    this._completeTime = 0
    this._startPosition = 0
    this._ease = gsap.parseEase(data.ease) || gsap.parseEase('linear')
    this._reelID = null
    this.updateWinReel = data.updateWinReel || false
  }

  start(position, time) {
    this._isComplete = false
    this._startTime = time
    this._startPosition = position

  }

  reset(){
    this._isComplete = false
    this._completeTime = 0

  }

  updatePosition(position, time) {
    if( this._isComplete) {
      return
    }
    let progress = Math.max(0, time - this._startTime - this._delay) / this._duration
    if (progress >= 1) {
      progress = 1
      this.completeCalculation(this._startTime + this._duration + this._delay)
      return this._startPosition + this._distance

    }
    else {
      return this._startPosition + (this._ease(progress) * this._distance)
    }
  }

  completeCalculation(time){
    if(this._isComplete ) {
      return
    }
    this._debug = true
    this._isComplete = true
    this._completeTime = time

  }

  get type(){
    return this._type
  }

  get reelID(){
    return this._reelID
  }

  get completeTime(){
    return this._completeTime
  }

  get isComplete(){
    return this._isComplete
  }

  get ease(){
    return  this._ease
  }

  get delay(){
    return  this._delay
  }

  get id(){
    return  this._id
  }

  get name(){
    return  this._name
  }

  get duration(){
    return  this._duration
  }

  get distance(){
    return  this._distance
  }

  set reelID(id){
    this._reelID = id
  }

  set ease(ease){
    this._ease = ease
  }

  set delay(delay){
    this._delay = delay

  }

  set id(id){
    this._id = id
  }

  set duration(duration){
    this._duration = duration
  }

  set distance(distance){
    this._distance = distance
  }

  set isComplete( isComplete){
    this._isComplete = isComplete
  }

  get startPosition(){
    return  this._startPosition
  }

  set startPosition(startPosition){
    this._startPosition = startPosition
  }

}
